import { GridColDef } from "@mui/x-data-grid-pro";

/**
 * GeneratePrincipalCentroCustoColumnDefs
 */

type Props = {
  onRegistradaClick: (idCentroCusto: number) => void;
  onEmAnaliseClick: (idCentroCusto: number) => void;
  onResolvidaClick: (idCentroCusto: number) => void;
};

export const GeneratePrincipalCentroCustoColumnDefs = ({
  onRegistradaClick,
  onEmAnaliseClick,
  onResolvidaClick,
}: Props): GridColDef[] => {
  return [
    {
      field: "legenda",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      align: 'left',
    },
    {
      field: "registradas",
      filterable: false,
      headerName: "Registradas",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: (params) => (
        <button onClick={() => onRegistradaClick(params.row.idCentroCusto)}>
          {params.value}
        </button>
      ),
    },
    {
      field: "analise",
      filterable: false,
      headerName: "Em Análise",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: (params) => (
        <button onClick={() => onEmAnaliseClick(params.row.idCentroCusto)}>
          {params.value}
        </button>
      ),
    },
    {
      field: "resolvidas",
      filterable: false,
      headerName: "Resolvidas",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: (params) => (
        <button onClick={() => onResolvidaClick(params.row.idCentroCusto)}>
          {params.value}
        </button>
      ),
    },
  ];
}